import pick from 'lodash/pick';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { onFetchPendingTx } from '../../util/api';
import { storableError } from '../../util/errors';
import { util as sdkUtil } from '../../util/sdkLoader';
import { PhoneNumber } from '../../components/FieldPhoneNumberInput/FieldPhoneNumberInput.example';
import moment from 'moment';

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/PendingApprovalPage/SET_INITIAL_VALUES';
export const FETCH_TRANSACTION_REQUEST = 'app/PendingApprovalPage/FETCH_TRANSACTION_REQUEST';
export const FETCH_TRANSACTION_SUCCESS = 'app/PendingApprovalPage/FETCH_TRANSACTION_SUCCESS';
export const FETCH_TRANSACTION_ERROR = 'app/PendingApprovalPage/FETCH_TRANSACTION_ERROR';

// ================ Reducer ================ //

const entityRefs = entities =>
  entities?.map(entity => ({
    id: entity?.id,
    type: entity?.type,
  }));

const initialState = {
  fetchTransactionInProgress: false,
  fetchTransactionError: null,
  pagination: null,
  transactionRefs: [],
};

export default function pendingApprovalPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {

    case FETCH_TRANSACTION_REQUEST:
      return { ...state, fetchTransactionInProgress: true, fetchTransactionError: null };

    case FETCH_TRANSACTION_SUCCESS: {
      const transactions = payload.data.data;
      return {
        ...state,
        fetchTransactionInProgress: false,
        transactionRefs: entityRefs(transactions),
        pagination:payload.data.meta,
      };
    }

    case FETCH_TRANSACTION_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchTransactionInProgress: false, fetchTransactionError: payload };

    default:
      return state;
  }
}

// ================ Selectors ================ //

export const transitionInProgress = state => {
  return state.TransactionPage && state.TransactionPage.transitionInProgress;
};

// ================ Action creators ================ //
export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

const fetchTransactionRequest = () => ({ type: FETCH_TRANSACTION_REQUEST });

const fetchTransactionSuccess = response => {
  
  // The reducer now expects the raw response shape and handles it.
  return {
    type: FETCH_TRANSACTION_SUCCESS,
    payload: response,
  };
};
const fetchTransactionError = e => ({ type: FETCH_TRANSACTION_ERROR, error: true, payload: e });

// ================ Thunks ================ //

export const fetchPendingApprovalTransaction = () => (dispatch) => {
  dispatch(fetchTransactionRequest());

  onFetchPendingTx({})
    .then(response => {
      // ensure marketplace entities are added regardless of response shape
      dispatch(addMarketplaceEntities(response));
      dispatch(fetchTransactionSuccess(response));
    })
    .catch(e => {
      dispatch(fetchTransactionError(storableError(e)));
    });
};

// Corrected adminCreateListing thunk
export const adminCreateListing = (listingParams = {}) => async (dispatch, getState, sdk) => {
  const origin = listingParams?.location?.selectedPlace?.origin || {}
  
  // Build a safe params object (use provided fields or sensible defaults)
  const params = {
    title: listingParams?.title || "",
    description: listingParams?.description || "",
    publicData: {
      location: listingParams?.location,
      phoneNumber: listingParams?.phoneNumber,
      email: listingParams?.email,
      listingDescription: listingParams?.description,
      updatedAt: moment().unix(),
      createdAt: moment().unix(),
      adminListing:true ,
      transactionProcessAlias:'default-booking/release-1',
      unitType: 'day',
      listingType:'rent_options',
      address: listingParams?.location?.search || "",
    },
  };
  if (origin) {
    params.geolocation = origin;
  }
  
  try {
    // Call the SDK to create the listing
    const response = await sdk.ownListings.create(params);
    return response;
  } catch (e) {
    const err = storableError(e);
    throw err;
  }
};


export function loadData(params, search, config) {
  return (dispatch, getState, sdk) => {
    return Promise.all([dispatch(fetchPendingApprovalTransaction())]);
  };
}

